/* global axios */
import ApiClient from './ApiClient';

class HomeDashboardAPI extends ApiClient {
  constructor() {
    super('home_dashboard', { accountScoped: true });
  }

  getMetrics() {
    return axios.get(this.url);
  }
}

export default new HomeDashboardAPI();
